var ArticleJs = function () {
  var init = function () {
    $('#article-kz-banner-registration').click(function() {
      window.dataLayer.push({ event: 'notification_click', 'notification.button': $('#article-kz-banner-registration').attr('data-tracking-button-name'), 'notification.type': 'registration' });
    })
    $('#article-kz-banner-login').click(function() {
      window.dataLayer.push({ event: 'notification_click', 'notification.button': $('#article-kz-banner-login').attr('data-tracking-button-name'), 'notification.type': 'login' });
    })
  };

  return {
    init: init
  };
}();

UL.register(ArticleJs);
